export enum Phase {
  PhaseOne = '1st Survey - Listening Phase',
  PhaseTwo = '2nd Survey - Solution Phase',
  PhaseThree = '3rd Survey - Confirmation Phase'
}

export enum PhaseColor {
  PhaseOne = '#70ad47',
  PhaseTwo = '#ff7f00',
  PhaseThree = '#0070c0'
}
